import transDynamic from 'djanjucks/filters/transDynamic'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'

export default function tDynamic(obj: unknown, field: string): string {
  const { context }: CommonContextStore = useContextStore()

  return transDynamic(obj, `${field},${context.current_language.iso},${context.need_translate}`)
}
